// OptiaéroLab — Theme JS

document.addEventListener('DOMContentLoaded', function() {

  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      const spans = menuToggle.querySelectorAll('span');
      if (isOpen) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  const productForms = document.querySelectorAll('#product-form, form[action="/cart/add"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(res => res.json())
      .then(data => {
        if (btn) {
          btn.textContent = '✓ Ajouté !';
          btn.style.background = '#2a9d4e';
          setTimeout(() => { btn.textContent = originalText; btn.style.background = ''; }, 2000);
        }
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.querySelectorAll('.cart-count').forEach(c => c.textContent = cart.item_count);
        });
      })
      .catch(err => console.error('Cart error:', err));
    });
  });

  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(0,0,0,0.4)' : '';
    }, { passive: true });
  }

});
